export default __webpack_public_path__ + "static/media/Tigerswipe.3b2c1039.jpg";